"use client";
import Image from "next/image";

import AmmIcon from "@/assets/amm-bot.gif";
import type { Maybe, PartialAccount } from "@/utils/types";

import { InfoTooltip } from "./info-tooltip";

type UserAmmIconProps = {
  width?: number;
  height?: number;
  className?: string;
  label?: string;
  username?: Maybe<string>;
  extraData?: PartialAccount["extraData"];
};

const DISPLAY_NAME = "Automated Market-Maker";

export const UserAmmIcon = ({
  extraData,
  username = "",
  width = 32,
  height = 32,
  label = DISPLAY_NAME,
  className,
}: UserAmmIconProps) => {
  const showAmmIcon =
    extraData?.DisplayName === DISPLAY_NAME && username?.startsWith("AMM_");

  if (!showAmmIcon) return null;

  return (
    <InfoTooltip text={<span className="text-xs text-muted">{label}</span>}>
      <Image
        src={AmmIcon}
        alt="whale"
        {...{ width, height }}
        className={className}
      />
    </InfoTooltip>
  );
};
